export default __webpack_public_path__ + "7040afb75f6c42d714f9316eb09e4c8d.png";